// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.layer-catalog {
    margin-top: 0.25em;
    height: 100%;
}

div.layer-catalog div.layer-catalog-widget {
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./plugins/style/LayerCatalog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["div.layer-catalog {\n    margin-top: 0.25em;\n    height: 100%;\n}\n\ndiv.layer-catalog div.layer-catalog-widget {\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
